module.exports = __webpack_public_path__ + "site/img/sd-Deng.8bcde581.png";